import api from './api';

export const postIniciarAtendimentoExterno = async () => {
  try {
    const response = await api.post('/atendimento/iniciarAtendimentoExterno');
    return response;
  } catch (error) {
    return { error };
  }
};

export const getPendenteAtendimento = async ({ page, numeroRegistros }) => {
  try {
    const response = await api.get(
      `/SolicitacaoConsulta/PendentesAtendimentoExterno?page=${page}&numeroRegistros=${numeroRegistros}`
    );
    return response;
  } catch (error) {
    return { error };
  }
};

export const patchPriorizarAtendimento = async idSolicitacao => {
  try {
    const { status } = await api.patch(
      `/SolicitacaoConsulta/Priorizar/${idSolicitacao}`
    );
    return { status };
  } catch (error) {
    return { error };
  }
};

export const putFinalizarAtendimentoExterno = async payload => {
  try {
    const response = await api.put('/Atendimento/FinalizarExterno', payload);
    return response;
  } catch (error) {
    return { error };
  }
};

export const getConsultasExternas = async () => {
  try {
    const response = await api.get(
      '/atendimento-externo/list-consultas-atendimento'
    );
    return response;
  } catch (error) {
    return { error };
  }
};

export const getDetalhesConsultaExterna = async idConsultaExterna => {
  try {
    const response = await api.get(
      `/atendimento-externo/detalhe-consulta/${idConsultaExterna}`
    );
    return response.data;
  } catch (error) {
    return { error };
  }
};

export const postIniciarAtendimentoConsultaExterna = async params => {
  try {
    const payload = {
      idConsultaSolicitacao: params.id
    };
    const response = await api.post(
      '/atendimento-externo/iniciar', payload
    );
    return response.data;
  } catch (error) {
    return { error };
  }
};

export const putFinalizarAtendimentoConsultaExterna = async ({ id, observacao, recomendada }) => {
  try {
    const payload = {
      id,
      observacao,
      recomendada
    };
    const response = await api.put(
      '/atendimento-externo/finalizar', payload
    );
    return { response };
  } catch (error) {
    return { error };
  }
};
